/**
 * Strips ?sort_by=... from collection-page URLs.
 *
 * Sort on this theme is applied client-side from window.collection_products,
 * so the URL param is purely cosmetic — removing it has no functional impact.
 *
 * Runs inline (non-defer) in <head> on collection pages so it patches
 * history.pushState/replaceState BEFORE any deferred scripts (opk-main-collection.js,
 * facets.js, etc.) can write the param back.
 *
 * Ticket: #7 "URL's zijn vreemd" / store-and-style-woerden-customisation
 */
(function () {
  function strip(url) {
    try {
      var u = new URL(url, window.location.href);
      // Normalise every history write: drop sort_by AND any dangling '?'
      // (opk-main-collection.js pushes a bare '?' when no filters are active).
      if (u.searchParams.has('sort_by') || /\?$/.test(url) || url === '') {
        u.searchParams.delete('sort_by');
        var q = u.searchParams.toString();
        return u.pathname + (q ? '?' + q : '') + u.hash;
      }
    } catch (e) {}
    return url;
  }

  if (window.location.search.indexOf('sort_by=') !== -1 || /\?$/.test(window.location.href)) {
    history.replaceState(history.state, '', strip(window.location.href));
  }

  var origPush = history.pushState;
  var origReplace = history.replaceState;
  history.pushState = function (state, title, url) {
    return origPush.call(this, state, title, url == null ? url : strip(url));
  };
  history.replaceState = function (state, title, url) {
    return origReplace.call(this, state, title, url == null ? url : strip(url));
  };
})();
